import { FEEDBACKS_API } from "../../../../constants/Configs"
import { API_REQUEST } from "../../../../constants/General"
import { Actions } from "../../../../redux/actions"
import API from "../../../../services/api"
import { getPageSize } from "../../../../services/middleware"
import { dispatch } from "../../../../utils/store"
import { handleError } from "../../../../utils/toast"
import { feedbacksListDTO } from "../dtos/feedbacks"

export const getFeedbacks = (search, startDate, endDate, sortBy, orderBy, page = 1) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  const params = {
    ...(!!search ? { search } : {}),
    ...(!!sortBy ? { sortBy } : {}),
    ...(!!orderBy ? { orderBy } : {}),
    ...(!!startDate ? { startDate } : {}),
    ...(!!endDate ? { endDate } : {}),
    ...(!!page ? { page, 'size': getPageSize() } : {}),
  }

  API(API_REQUEST.get, FEEDBACKS_API, { params })
    .then(res => {
      dispatch(Actions.RestaurantAdminFeedbacks.SetFeedbacks, feedbacksListDTO(res?.data?.data?.rows))
      dispatch(Actions.RestaurantAdminFeedbacks.SetTotalCount, res?.data?.data?.count || 0)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}